import { MapPin, Navigation, Clock } from "lucide-react";
import { Reveal } from "./Reveal";
import { Eucalyptus, Divider } from "./Botanical";

const LINKS = [
  {
    id: "balad",
    label: "بلد",
    href: "https://balad.ir/p/30lHrTqIxNC2eu?preview=true#18/35.699165/51.183922",
  },
  {
    id: "google",
    label: "گوگل مپ",
    href: "https://www.google.com/maps/search/?api=1&query=35.699165,51.183922",
  },
  { id: "neshan", label: "نشان", href: "https://nshn.ir/_bvh2uPxGG90" },
];

export const Venue = () => (
  <section
    id="venue"
    data-testid="wedding-venue-section"
    className="relative px-4 sm:px-8 lg:px-12 pt-24 sm:pt-36 pb-16 sm:pb-20 overflow-x-clip"
  >
    <Eucalyptus className="pointer-events-none absolute -top-32 sm:-top-36 -left-10 sm:-left-12 w-[clamp(calc(14rem*var(--bmin)),calc(0.24*var(--cw)),22rem)] opacity-90 rotate-180 -scale-x-100" />
    <Eucalyptus className="pointer-events-none absolute -bottom-8 -right-8 w-[clamp(calc(12rem*var(--bmin)),calc(0.2*var(--cw)),20rem)] opacity-80 rotate-180" />

    <div className="max-w-6xl mx-auto relative">
      <Reveal>
        <p
          data-testid="venue-poetry"
          className="text-center text-base sm:text-lg font-light leading-loose text-[#6E6459] max-w-xl mx-auto mb-14"
        >
          در شبی که مهر دست در دست سرنوشت می‌گذارد،
          <br />
          ما به شادی گرد هم می‌آییم تا فصلی نو را جشن بگیریم
        </p>
        <Divider className="w-52 sm:w-64 mx-auto mb-14 opacity-90" />
      </Reveal>
      <div className="flex justify-center">
        <Reveal delay={0.15} className="w-full max-w-xl">
          <div className="rounded-[2rem] bg-white border border-[#E6DEC8] p-8 sm:p-10 shadow-[0_30px_60px_-40px_rgba(26,22,18,0.25)]">
            <p className="text-xs text-[#8C827A] mb-3 flex items-center gap-2">
              <MapPin size={13} className="text-[#C29B38]" />
              محل برگزاری
            </p>
            <p className="text-sm sm:text-base text-[#1A1612] leading-relaxed font-light" data-testid="venue-address">
              تهران، بزرگراه فتح غرب (متوسلیان)، کیلومتر ۱۴ لاین کندرو، چهارراه ایرانخودرو، به سمت شهرک دانش، خیابان تولایی، کوچه لاله، انتهای کوچه، پلاک ۳، باغ تماشا
            </p>

            <div className="mt-10">
              <p className="text-xs text-[#8C827A] mb-5 flex items-center gap-2">
                <Navigation size={13} className="text-[#C29B38]" />
                مسیریابی
              </p>
              <div className="flex flex-wrap gap-3">
                {LINKS.map((l) => (
                  <a
                    key={l.id}
                    data-testid={`map-button-${l.id}`}
                    href={l.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 rounded-full border border-[#1A1612]/20 bg-white px-5 py-2.5 text-sm text-[#1A1612] transition-all duration-300 hover:border-[#C29B38] hover:text-[#C29B38] active:scale-95"
                  >
                    <Navigation size={14} />
                    {l.label}
                  </a>
                ))}
              </div>
            </div>

            <div className="mt-10">
              <p className="text-xs text-[#8C827A] mb-6 flex items-center gap-2">
                <Clock size={13} className="text-[#C29B38]" />
                برنامهٔ شب
              </p>
              <ul className="space-y-5 text-sm sm:text-base font-light">
                {[
                  ["آیین عقد", "۱۷:۰۰"],
                  ["مراسم عروسی", "۱۹:۰۰"],
                ].map(([text, time]) => (
                  <li key={text} className="flex items-center gap-4">
                    <span className="text-[#1A1612]">{text}</span>
                    <span className="h-px flex-1 bg-[#E6DEC8]" />
                    <span className="text-[#C29B38] font-light tabular-nums whitespace-nowrap">{time}</span>
                  </li>
                ))}
              </ul>
              <p className="mt-7 text-xs sm:text-sm font-light leading-relaxed text-[#1A1612]" data-testid="venue-mixed-note">
                احتراماً خاطرنشان می‌شود این مراسم در فضایی مشترک با حضور بانوان و آقایان برگزار می‌شود
              </p>
            </div>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
